import ReactDOM from 'react-dom';
import { createBrowserHistory, History } from 'history';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import {
    ConnectedRouter,
    connectRouter,
    routerMiddleware
} from 'connected-react-router';
import { Route, Switch } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import Reducers from './reducers/Reducers';
import STORE from './store';
import Login from './Login';
import AuthorizedRoute from './AuthorizedRoute';
import Orders from './Orders';
import WorkingHours from './WorkingHours';
import AllTables from './AllTables';
import { OPEN_ORDER_PATH, RESERVATIONS, TABLES, WORKING_HOURS } from './Constants';
import Notifier from './Notifier';
import Reservations from './Reservations';

import 'moment/locale/el';
import './styles/main.less';

const browserHistory = createBrowserHistory();
const middlewares: any[] = [thunk, routerMiddleware(browserHistory)];

if (process.env.NODE_ENV === 'development') {
    const logger = createLogger({
        collapsed: true,
        titleFormatter: action => `${action.type}`
    });
    middlewares.push(logger);
}

const createRootReducer = (history: History) =>
    combineReducers({
        router: connectRouter(history),
        app: Reducers
    });

const configureStore = (initialState = STORE) =>
    createStore(
        createRootReducer(browserHistory),
        initialState,
        applyMiddleware(...middlewares)
    );

ReactDOM.render(
    <Provider store={configureStore()}>
        <ConnectedRouter history={browserHistory}>
            <SnackbarProvider
                maxSnack={4}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                hideIconVariant>
                <Notifier />
                <Switch>
                    <Route exact path='/' component={Login} />
                    <Switch>
                        <AuthorizedRoute
                            exact
                            path={OPEN_ORDER_PATH}
                            component={Orders}
                        />
                        <AuthorizedRoute
                            exact
                            path={WORKING_HOURS}
                            component={WorkingHours}
                        />
                        <AuthorizedRoute exact path={TABLES} component={AllTables} />
                        <AuthorizedRoute
                            exact
                            path={RESERVATIONS}
                            component={Reservations}
                        />
                    </Switch>
                </Switch>
            </SnackbarProvider>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);
